export default __webpack_public_path__ + "static/media/danta_dark_female.06aa2ee6.png";